export default {
  easypayOption: 'naverpay',
  __typename: 'CheckoutEasyPay'
};
